// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"styles_inputWrapper__3aE7D","input":"styles_input__2SwAR"};